var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"font-weight-bold accent-4",class:{ 'amber--text': _vm.nearLimit, 'red--text': _vm.atLimit }},[_vm._v(" "+_vm._s(_vm.smsCount(_vm.value, true, _vm.max))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }